import { render, staticRenderFns } from "./ServicesCategoriesList.vue?vue&type=template&id=38dbde2e&scoped=true"
import script from "./ServicesCategoriesList.vue?vue&type=script&lang=js"
export * from "./ServicesCategoriesList.vue?vue&type=script&lang=js"
import style0 from "./ServicesCategoriesList.vue?vue&type=style&index=0&id=38dbde2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dbde2e",
  null
  
)

export default component.exports